import { useSelector } from 'react-redux';
import { Store } from 'types/Store';
import { AccountStore } from 'modules/account/accountReducer';

export function useAccount(): AccountStore {
  return useSelector<Store, AccountStore>((state) => state.account);
}
